/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Two_Fa_Setup_TitleInputs */

const en_two_fa_setup_title = /** @type {(inputs: Two_Fa_Setup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set up two-factor authentication`)
};

const nl_two_fa_setup_title = /** @type {(inputs: Two_Fa_Setup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twee-factor-authenticatie instellen`)
};

/**
* | output |
* | --- |
* | "Set up two-factor authentication" |
*
* @param {Two_Fa_Setup_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const two_fa_setup_title = /** @type {((inputs?: Two_Fa_Setup_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Two_Fa_Setup_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_two_fa_setup_title(inputs)
	return en_two_fa_setup_title(inputs)
});